/**
 * Generate an array of years to present
 *
 * @return {Array}
 */
const generateYears = () => {
    let yearArray = [];
    const now = new Date().getFullYear();
    for (let i = now; i >= 2012; i--) {
        yearArray.push({id: i, name: i.toString()});
    }
    return yearArray;
};

export const YEARS = generateYears();

export const MONTHS = [
    {id: '01', name: 'January', days: 31},
    {id: '02', name: 'February', days: 29},
    {id: '03', name: 'March', days: 31},
    {id: '04', name: 'April', days: 30},
    {id: '05', name: 'May', days: 31},
    {id: '06', name: 'June', days: 30},
    {id: '07', name: 'July', days: 31},
    {id: '08', name: 'August', days: 31},
    {id: '09', name: 'September', days: 30},
    {id: '10', name: 'October', days: 31},
    {id: '11', name: 'November', days: 30},
    {id: '12', name: 'December', days: 31},
];

export const MONTHS_NUMBERS = [
    {id: '1', name: 'January', days: 31},
    {id: '2', name: 'February', days: 29},
    {id: '3', name: 'March', days: 31},
    {id: '4', name: 'April', days: 30},
    {id: '5', name: 'May', days: 31},
    {id: '6', name: 'June', days: 30},
    {id: '7', name: 'July', days: 31},
    {id: '8', name: 'August', days: 31},
    {id: '9', name: 'September', days: 30},
    {id: '10', name: 'October', days: 31},
    {id: '11', name: 'November', days: 30},
    {id: '12', name: 'December', days: 31},
];

export const MONTH_NAMES = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

/**
 * Generate a list of days in a selected month
 *
 * @param limit
 * @returns {*[]}
 */
export const generateDaysInMonth = (limit) => {
    let daysArray = [];
    for (let i = 1; i <= limit; i++) {
        daysArray.push({id: String('00' + i).slice(-2), name: i.toString()});
    }
    return daysArray;
};

/**
 * Generate an array of a month of days back from current day
 *
 * @return {*}
 */
const generateDaysBack = () => {
    let daysArray = [];
    for (let i = 0; i < 31; i++) {
        let minVal = i.toString();
        let minObj = {id: minVal, name: minVal};
        if (i === 0) {
            minObj.name = '0 (Same Day)';
        }
        if (i === 6) {
            minObj.name = '6 (Selected Day + 1 Week Back)';
        }
        if (i === 13) {
            minObj.name = '13 (Selected Day + 2 Weeks Back)';
        }
        if (i === 20) {
            minObj.name = '20 (Selected Day + 3 Weeks Back)';
        }
        if (i === 30) {
            minObj.name = '30 (Selected Day + 1 Month Back)';
        }
        daysArray.push(minObj);
    }
    return daysArray;
};

export const DAYS_BACK = generateDaysBack();

export const WEEKDAYS = [
    {id: 'sunday', name: 'Sunday'},
    {id: 'monday', name: 'Monday'},
    {id: 'tuesday', name: 'Tuesday'},
    {id: 'wednesday', name: 'Wednesday'},
    {id: 'thursday', name: 'Thursday'},
    {id: 'friday', name: 'Friday'},
    {id: 'saturday', name: 'Saturday'}
];

export const HOURS = [
    {id: '00', name: '12'},
    {id: '01', name: '1'},
    {id: '02', name: '2'},
    {id: '03', name: '3'},
    {id: '04', name: '4'},
    {id: '05', name: '5'},
    {id: '06', name: '6'},
    {id: '07', name: '7'},
    {id: '08', name: '8'},
    {id: '09', name: '9'},
    {id: '10', name: '10'},
    {id: '11', name: '11'}
];

export const REPORT_FREQUENCY = [
    {id: 'weekly', name: 'Weekly'},
    {id: 'daily', name: 'Daily'}
];

/**
 * Generate an array of 24 hours
 *
 * @returns {Array}
 */
const generate24Hours = () => {
    let arr = [];
    for (let i = 0; i < 24; i++) {
        let val = String('00' + i).slice(-2);
        let obj = {id: val, name: val};
        arr.push(obj);
    }
    return arr;
};

export const HOURS_24 = generate24Hours();

export const HOURS_24_AMPM = [
    {id: '00', name: '12am midnight'},
    {id: '01', name: '1am'},
    {id: '02', name: '2am'},
    {id: '03', name: '3am'},
    {id: '04', name: '4am'},
    {id: '05', name: '5am'},
    {id: '06', name: '6am'},
    {id: '07', name: '7am'},
    {id: '08', name: '8am'},
    {id: '09', name: '9am'},
    {id: '10', name: '10am'},
    {id: '11', name: '11am'},
    {id: '12', name: '12pm noon'},
    {id: '13', name: '1pm'},
    {id: '14', name: '2pm'},
    {id: '15', name: '3pm'},
    {id: '16', name: '4pm'},
    {id: '17', name: '5pm'},
    {id: '18', name: '6pm'},
    {id: '19', name: '7pm'},
    {id: '20', name: '8pm'},
    {id: '21', name: '9pm'},
    {id: '22', name: '10pm'},
    {id: '23', name: '11pm'},
];

/**
 * Generate an array of minutes in an hour
 *
 * @return {Array}
 */
const generateMinutes = () => {
    let minArray = [];
    for (let i = 0; i < 60; i++) {
        let minVal = String('00' + i).slice(-2);
        let minObj = {id: minVal, name: minVal};
        minArray.push(minObj);
    }
    return minArray;
};

export const MINUTES = generateMinutes();

export const MINUTES_QUARTER = [
    {id: '00', name: '00'},
    {id: '15', name: '15'},
    {id: '30', name: '30'},
    {id: '45', name: '45'},
    {id: '59', name: '59'}
];

export const AMPM = [
    {id: 'am', name: 'AM'},
    {id: 'pm', name: 'PM'}
];

export const TIME_ZONES = [
    {id: 'Pacific/Honolulu', name: 'Hawaii-Aleutian Time'},
    {id: 'America/Anchorage', name: 'Alaska Time'},
    {id: 'America/Los_Angeles', name: 'Pacific Time'},
    {id: 'America/Denver', name: 'Mountain Time'},
    {id: 'America/Chicago', name: 'Central Time'},
    {id: 'America/New_York', name: 'Eastern Time'}
];

export const TIME_ZONE_OFFSETS = [
    {id: '-10:00', name: 'UTC-10:00', offset: 600, tzStd: 'HST', tzDay: 'HST'},
    {id: '-09:00', name: 'UTC-09:00', offset: 540, tzStd: '', tzDay: 'HDT'},
    {id: '-08:00', name: 'UTC-08:00', offset: 480, tzStd: 'PST', tzDay: 'AKDT'},
    {id: '-07:00', name: 'UTC-07:00', offset: 420, tzStd: 'MST', tzDay: 'PDT'},
    {id: '-06:00', name: 'UTC-06:00', offset: 360, tzStd: 'CST', tzDay: 'MDT'},
    {id: '-05:00', name: 'UTC-05:00', offset: 300, tzStd: 'EST', tzDay: 'CDT'},
    {id: '-04:00', name: 'UTC-04:00', offset: 240, tzStd: 'AST', tzDay: 'EDT'}
];

/**
 * Determine if daylight time is observed during a specific date
 *
 * @param date
 * @returns {boolean}
 */
export const isDaylightObserved = (date) => {
    const jan = new Date(date.getFullYear(), 0, 1);
    const jul = new Date(date.getFullYear(), 6, 1);
    const standardTZOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    return date.getTimezoneOffset() < standardTZOffset;
};

/**
 * Get a time zone object for today
 *
 * @returns {string|*}
 */
export const getTimeZoneOffsetDefault = () => {
    const date = new Date();
    const idx = TIME_ZONE_OFFSETS.findIndex(r => r.offset === date.getTimezoneOffset());
    if (idx !== -1) {
        return TIME_ZONE_OFFSETS[idx].id;
    }
    return null;
};

/**
 * Get a time zone object by offset hour
 *
 * @param hour
 * @returns {{offset: number, tzStd: string, name: string, id: string, tzDay: string}|{offset: number, tzStd: string, name: string, id: string, tzDay: string}|{offset: number, tzStd: string, name: string, id: string, tzDay: string}|{offset: number, tzStd: string, name: string, id: string, tzDay: string}|{offset: number, tzStd: string, name: string, id: string, tzDay: string}|null}
 */
export const getTimeZoneObjectByOffsetHour = (hour) => {
    const idx = TIME_ZONE_OFFSETS.findIndex(r => r.id === hour);
    if (idx !== -1) {
        return TIME_ZONE_OFFSETS[idx];
    }
    return null;
};

/**
 * Get a time zone abbreviation by specific date and offset hour
 *
 * @param datetime
 * @param offset
 * @returns {string}
 */
export const getTimeZoneByDateAndOffset = (datetime, offset) => {
    const utcDate = new Date(datetime);
    const isDst = isDaylightObserved(utcDate);
    const tzObj = getTimeZoneObjectByOffsetHour(offset);
    if (tzObj) {
        if (isDst) {
            return tzObj.tzDay;
        } else {
            return tzObj.tzStd;
        }
    }
    return '';
};



// WEBPACK FOOTER //
// ./src/Fuse/shared/dateTimeLists.js